import { useNavigate } from 'react-router-dom';
import {
  Link,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { FieldWrapper } from './FieldWrapper';
import { useFieldReadOnly } from './fieldReadOnly';
import type { FieldComponentProps } from './types';

const useStyles = makeStyles({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: '32px',
  },
  readOnlyLink: {
    paddingInlineStart: tokens.spacingHorizontalM,
  },
});

export const LinkField = ({
  field,
  fieldValue,
  validationMessage,
}: FieldComponentProps) => {
  const navigate = useNavigate();
  const styles = useStyles();
  const isReadOnly = useFieldReadOnly(field);

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <Link
        className={mergeClasses(styles.link, isReadOnly && styles.readOnlyLink)}
        onClick={() => {
          if (fieldValue) {
            const target = field.options?.linkUrl?.replace('{id}', fieldValue);
            if (target) navigate(target);
          }
        }}
      >
        {fieldValue ?? ''}
      </Link>
    </FieldWrapper>
  );
};
